var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalculatorArrowMobile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 44 114"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.415 112C7.976 96.427-.448 39 41 39",
    stroke: "url(#calculator-arrow-mobile_svg__paint0_linear_4207_603)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.554 29l18.076 9.064-9.898 15.113",
    stroke: "#E5E5E5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "calculator-arrow-mobile_svg__paint0_linear_4207_603",
    x1: 24.977,
    y1: 39,
    x2: 24.977,
    y2: 158.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5E5E5",
    stopOpacity: 0
  })))));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDQiIGhlaWdodD0iMTE0IiB2aWV3Qm94PSIwIDAgNDQgMTE0IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8ZyBpZD0iQXJyb3ciPgo8cGF0aCBpZD0iVmVjdG9yIDMiIGQ9Ik0zMi40MTQ5IDExMkM3Ljk3NjM0IDk2LjQyNjcgLTAuNDQ3ODgzIDM5IDQxIDM5IiBzdHJva2U9InVybCgjcGFpbnQwX2xpbmVhcl80MjA3XzYwMykiIHN0cm9rZS13aWR0aD0iNCIvPgo8cGF0aCBpZD0iVmVjdG9yIDQiIGQ9Ik0yMi41NTM3IDI5TDQwLjYzMDEgMzguMDY0MUwzMC43MzE4IDUzLjE3NzQiIHN0cm9rZT0iI0U1RTVFNSIgc3Ryb2tlLXdpZHRoPSI0Ii8+CjwvZz4KPGRlZnM+CjxsaW5lYXJHcmFkaWVudCBpZD0icGFpbnQwX2xpbmVhcl80MjA3XzYwMyIgeDE9IjI0Ljk3NyIgeTE9IjM5IiB4Mj0iMjQuOTc3IiB5Mj0iMTU4LjcyIiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+CjxzdG9wIHN0b3AtY29sb3I9IiNFNUU1RTUiLz4KPHN0b3Agb2Zmc2V0PSIxIiBzdG9wLWNvbG9yPSIjRTVFNUU1IiBzdG9wLW9wYWNpdHk9IjAiLz4KPC9saW5lYXJHcmFkaWVudD4KPC9kZWZzPgo8L3N2Zz4K";
export { SvgCalculatorArrowMobile as ReactComponent };